import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { AuthenticationService } from '../services/auth.service';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
    constructor(private authenticationService: AuthenticationService,private toastr: ToastrService,private route: Router) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(catchError(err => {
            if (err.status === 401) {
                this.toastr.error('Session expired. Please login again.', 'Error',)
                // auto logout if 401 response returned from apis
                sessionStorage.clear();
                localStorage.clear();
                this.route.navigate(['/account/login']);
                // this.authenticationService.logout();
                // location.reload();
            }

            const error = err.error.message || err.statusText;
            return throwError(error);
        }));
    }
}
